import styled from 'styled-components'
import {Button} from '../../base/button'

const Styled = {
    Button: styled(Button)`
        display: flex;
        align-items: center;
        justify-content: center;

        &[data-hovered] {
            background-color: transparent;
        }

        &[data-disabled] {
            background-color: transparent;
            cursor: not-allowed;
            opacity: 0.5;
        }

        &[data-disabled][data-hovered] {
            background-color: transparent;
        }
    `,
}

export default Styled
